import { initializeApp } from "firebase/app"
import { getAuth, connectAuthEmulator } from "firebase/auth"
import { getStorage } from "firebase/storage"
import { ENVIRONMENTS } from "../consts/enviroments.consts"

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
}
const firebaseApp = initializeApp(firebaseConfig)

const auth = getAuth(firebaseApp)
auth.languageCode = "es"

if (process.env.REACT_APP_ENVIROMENT === ENVIRONMENTS.EMULATOR) {
  connectAuthEmulator(auth, "http://localhost:9099")
}

// Get a reference to the storage service, which is used to create references in your storage bucket
const storage = getStorage(firebaseApp)

export { storage, auth }
